import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { getFavoriteKeywords, getKeywordExceptSearch } from '../../api/product'
import { colorObj } from '../../components/color'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { useAppContext } from '../../components/provider/AppProvider'
import '../../css/Search.css'
import { delAllRecentlySearchWord, delRecentlySearchWord, setRecentlySearchWord } from '../../js/script'
import { RNPostMessage, AFWebLinkType } from '../../js/postMessage'

export default function SearchPage() {
  const [keyword, setKeyword] = useState<string>('')
  const [popularSearch, setPopularSearch] = useState<string[]>([''])
  const [recentKeyword, setRecentKeyword] = useState<any>([])
  const [searchKeyword, setSearchKeyword] = useState<boolean>(false)
  const [deleteRecent, setDeleteRecent] = useState<boolean>(false)
  const [allSearch, setAllSearch] = useState<any>([])
  const [filterSearch, setFilterSearch] = useState([])
  const [page, setPage] = useState<number>(1)
  const searchRef = useRef<HTMLInputElement>(null)
  const navigate = useNavigate()
  const { setIsLottie } = useCommonContext()
  const { isAppView } = useAppContext()
  const onChangeData = (e: React.FormEvent<HTMLInputElement>) => {
    setKeyword(e.currentTarget.value)
  }

  useEffect(() => {
    getKeywordExceptSearch('POPULAR', page, '', '787334')
      .then((res) => {
        setAllSearch((prev: any) => [...prev, ...res.data.items])
        setPage(2)
      })
      .catch((err) => console.log(err))
  }, [page, keyword])

  const fetchData = () => {
    const filteredArray = allSearch.filter((el: any) => el.productName.includes(keyword))
    setFilterSearch(filteredArray) // 상태를 한 번만 업데이트
  }

  const updateData = async () => {
    fetchData()
  }

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (keyword) updateData()
    }, 0)

    return () => {
      clearTimeout(debounce)
    }
  }, [keyword]) //키워드가 변경되면 api를 호출

  useEffect(() => {
    getFavoriteKeywords()
      .then((res) => {
        setPopularSearch(res.data)
        setIsLottie(false)
      })
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    if (keyword) {
      setRecentlySearchWord(keyword)
    }
  }, [searchKeyword])

  useEffect(() => {
    if (window.localStorage.getItem('recentlySearchWord')) {
      const recent: any = window.localStorage.getItem('recentlySearchWord')
      const recentParse = JSON.parse(recent)
      setRecentKeyword(recentParse)
    } else {
      setRecentKeyword([])
    }
  }, [deleteRecent])

  useEffect(() => {
    if (keyword) {
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = 'unset'
      }
    }
  }, [keyword])

  function isFirstCharSpace(input: any) {
    return input.charAt(0) === ' '
  }

  return (
    <>
      <div className='main_wrap'>
        {/* <PageTitle>검색</PageTitle> */}
        <SearchWrap>
          <SearchBarWrap>
            <SearchBar
              ref={searchRef}
              type='search'
              onChange={onChangeData}
              value={keyword}
              placeholder='검색어를 입력해 보세요.'
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  if (keyword && !isFirstCharSpace(keyword)) {
                    setSearchKeyword((prev: boolean) => !prev)
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search/searchResult?keyword=${keyword}`,
                      })
                    } else {
                      navigate(`/search/searchResult?keyword=${keyword}`)
                    }
                    setRecentlySearchWord(keyword)
                  } else {
                    alert('첫자리 공백은 검색이 불가합니다.')
                  }
                }
              }}
            />
            {keyword ? (
              <SearchResetBtn>
                <img
                  src='/images/icon_search_delete.svg'
                  alt='검색어 초기화'
                  onClick={(e) => {
                    e.preventDefault()
                    searchRef.current?.focus()
                    setKeyword('')
                  }}
                />
              </SearchResetBtn>
            ) : null}
            <SearchIcon
              src={`/images/icon_search.png`}
              onClick={() => {
                if (keyword && !isFirstCharSpace(keyword)) {
                  setSearchKeyword((prev: boolean) => !prev)
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search/searchResult?keyword=${keyword}`,
                    })
                  } else {
                    navigate(`/search/searchResult?keyword=${keyword}`)
                  }
                  setRecentlySearchWord(keyword)
                } else {
                  alert('첫자리 공백은 검색이 불가합니다.')
                }
              }}
            />
          </SearchBarWrap>

          {/* 자동 검색 목록 */}
          {keyword ? (
            <AutoSearchWrap className='auto_search_wrap'>
              {filterSearch.map((el: any) => {
                const firstEIndex = el.productName.indexOf(keyword)
                const keywordNumber = keyword.length
                const beforeE = el.productName.slice(0, firstEIndex)
                const afterE = el.productName.slice(firstEIndex + keywordNumber)
                return (
                  <AutoSearchContentBox
                    key={el.productNo}
                    onClick={() => {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.moveToLink, {
                          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search/searchResult?keyword=${el.productName}`,
                        })
                      } else {
                        navigate(`/search/searchResult?keyword=${el.productName}`)
                      }
                      setKeyword('')
                      setRecentlySearchWord(el.productName)
                    }}
                  >
                    <AutoSearchContent>
                      {beforeE}
                      <span style={{ color: colorObj.colPointBlue }}>{keyword}</span>
                      {afterE}
                    </AutoSearchContent>
                  </AutoSearchContentBox>
                )
              })}
            </AutoSearchWrap>
          ) : null}
          <SearchResultWrap className='search_result_wrap'>
            {recentKeyword?.length !== 0 ? (
              <RecentSearchWrap>
                <RecentSearchTitleWrap>
                  <Title>최근 검색어</Title>
                  <RecentAllDelete
                    onClick={() => {
                      delAllRecentlySearchWord()
                      setDeleteRecent((prev: boolean) => !prev)
                    }}
                  >
                    전체삭제
                  </RecentAllDelete>
                </RecentSearchTitleWrap>
                <RecentSearchContentWrap>
                  {recentKeyword?.slice(0, 9)?.map((el: string) => {
                    return (
                      <RecentSearchContent key={el}>
                        <RecentSearch
                          onClick={() => {
                            navigate(`/search/searchResult?keyword=${el}`)
                            setKeyword('')
                            setRecentlySearchWord(el)
                          }}
                        >
                          {el}
                        </RecentSearch>
                        <img
                          src='/images/icon_search_delete_gray.svg'
                          alt='최근 검색어 삭제'
                          onClick={() => {
                            delRecentlySearchWord(el)
                            setTimeout(() => {
                              setDeleteRecent((prev: boolean) => !prev)
                            }, 200)
                          }}
                        />
                      </RecentSearchContent>
                    )
                  })}
                </RecentSearchContentWrap>
              </RecentSearchWrap>
            ) : (
              <RecentSearchWrap>
                <RecentSearchTitleWrap>
                  <Title>최근 검색어</Title>
                </RecentSearchTitleWrap>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '16px',
                  }}
                >
                  <p
                    style={{
                      fontSize: '16px',
                      lineHeight: '24px',
                      fontWeight: '500',
                      color: '#AAA',
                    }}
                  >
                    최근 검색어가 없습니다.
                  </p>
                </div>
              </RecentSearchWrap>
            )}
            <PopularSearchBox>
              <Title>인기 검색어</Title>
              <PopularSearchWrap>
                <div>
                  {popularSearch.slice(0, 5).map((el: string, idx: number) => {
                    return (
                      <PopularSearch
                        key={idx}
                        onClick={() => {
                          setRecentlySearchWord(el)
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search/searchResult?keyword=${el}`,
                            })
                          } else {
                            navigate(`/search/searchResult?keyword=${el}`)
                          }
                        }}
                      >
                        <PopularRanking
                          style={{
                            color: idx + 1 <= 3 ? 'var(--colPointOrange)' : 'var(--colGray6)',
                          }}
                        >
                          {idx + 1}
                        </PopularRanking>
                        <PopularContent>{el}</PopularContent>
                      </PopularSearch>
                    )
                  })}
                </div>
                <div>
                  {popularSearch.slice(5, 10).map((el: string, idx: number) => {
                    return (
                      <PopularSearch
                        key={idx}
                        onClick={() => {
                          setRecentlySearchWord(el)
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search/searchResult?keyword=${el}`,
                            })
                          } else {
                            navigate(`/search/searchResult?keyword=${el}`)
                          }
                        }}
                      >
                        <PopularRanking>{idx + 6}</PopularRanking>
                        <PopularContent>{el}</PopularContent>
                      </PopularSearch>
                    )
                  })}
                </div>
              </PopularSearchWrap>
            </PopularSearchBox>
          </SearchResultWrap>
        </SearchWrap>
      </div>
    </>
  )
}

//검색전체
export const SearchWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  padding: 0 20px 48px;
  @media screen and (min-width: 768px) {
    padding: 0;
  }
`
//검색 바 감싼 div
export const SearchBarWrap = styled.div`
  width: 100%;
  border-radius: 10px;
  position: relative;
  /* margin-bottom: 24px; */
  box-sizing: border-box;

  &.fixed {
    position: sticky;
    top: 60px;
    background-color: var(--colWhite) !important;
    border: 0 !important;
    border-radius: 0;
    z-index: 10;
    padding: 0 20px;
    margin: 0 -20px;
    width: calc(100% + 40px);

    & .inner {
      position: relative;
    }
  }
`
//검색 바 input
export const SearchBar = styled.input`
  background: var(--colGray1);
  border: none;
  outline: none;
  width: 100%;
  height: 48px;
  font-size: 16px;
  line-height: 20px;
  padding: 15px 80px 15px 16px;
  font-weight: 500;
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  &::placeholder {
    color: var(--colGray6);
    line-height: 20px;
  }
  &:focus {
    background: var(--colWhite);
    box-shadow: inset 0 0 0 1px var(--colBlack);
    border: none;
  }
  &:focus::placeholder {
    color: var(--colGray5);
  }
`
//검색바 아이콘
export const SearchIcon = styled.img`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
`
// 검색바 x 버튼 감싸는 div
export const SearchResetBtn = styled.div`
  position: absolute;
  background: var(--colGray4);
  display: flex;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  top: 15px;
  right: 48px;
`
//검색 결과
export const SearchResultWrap = styled.div`
  width: 100%;
  padding-top: 24px;
  margin-bottom: 48px;
`
//자동완성 div
export const AutoSearchWrap = styled.div`
  background: var(--colWhite);
  position: absolute;
  top: 52px;
  left: 0;
  width: 100%;
  height: calc(100vh - 112px);
  /* max-height: 400px; */
  padding: 0 20px;
  z-index: 30;
  overflow-y: auto;
  overflow-x: hidden;
`
//자동완성 한줄 div
export const AutoSearchContentBox = styled.div`
  padding: 16px 0 15px;
  border-bottom: 1px solid #f0f0f0;
`
//자동완성 컨텐츠
export const AutoSearchContent = styled.p`
  font-size: 15px;
  line-height: 18px;
  font-weight: 500;
  text-overflow: ellipsis;
  word-break: keep-all;
`
export const PopularSearchBox = styled.div``
// 인기 검색어 or 최근검색어
export const Title = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: #191919;
`
//인기 검색어 감싼 div
export const PopularSearchWrap = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 2px;
  & > div {
    flex: 1;
  }
`
//인기 검색어 div
export const PopularSearch = styled.div`
  padding: 14px 0;
  display: flex;
  justify-content: flex-start;
  gap: 0 2px;
  border-bottom: 1px solid #e9e9e9;
`
// 순위
export const PopularRanking = styled.p`
  min-width: 18px;
  color: var(--colGray6);
  font-size: 15px;
  line-height: 18px;
  font-weight: 500;
`
//인기 검색어
export const PopularContent = styled(PopularRanking)`
  color: var(--colBlack);
  font-weight: 500;
`
//최근 검색어 감싼 div
export const RecentSearchWrap = styled.div`
  margin-bottom: 36px;
`
//최근 검색어 컨텐츠 감싼 div
export const RecentSearchContentWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px 8px;
  padding-top: 16px;
`
//최근 검색어 div
export const RecentSearchContent = styled.div`
  background: var(--colGray1);
  border: 1px solid var(--colGray3);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 17px;
  padding: 8px 10px 8px 14px;
  gap: 0 4px;
`
//최근 검색어
export const RecentSearch = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: var(--colBlack);
  font-weight: 500;
`
//최근 검색어 title 감싼 div
export const RecentSearchTitleWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
//최근 검색어 전체 삭제
export const RecentAllDelete = styled.span`
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  color: var(--colGray6);
`
